import PostsService from '../../../modules/posts/postsService'
import Errors from '../../../modules/shared/error/errors'
import { push } from 'redux-first-history'

const prefix = 'POSTS_VIEW'

const postsViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: postsViewActions.FIND_STARTED,
      })

      const record = await PostsService.find(id)

      dispatch({
        type: postsViewActions.FIND_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: postsViewActions.FIND_ERROR,
      })

      dispatch(push('/posts'))
    }
  },
}

export default postsViewActions
